<template>
  <el-select
    class="width-100"
    v-model="value"
    filterable
    remote
    :placeholder="placeholder ? placeholder : 'Gõ để tìm kiếm'"
    :remote-method="remoteMethod"
    @change="$emit('input', value)"
    :loading="loading"
  >
    <el-option
      v-for="item in clients"
      :key="item.id"
      :label="`${item.name} - ${item.shop_name}`"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
<script>
import { getAllClient } from 'src/api/client'
export default {
  name: 'SelectClient',
  props: ['value', 'placeholder'],
  data() {
    return {
      clients: [],
      loading: false,
    }
  },
  methods: {
    remoteMethod(query) {
      this.loading = true
      getAllClient({ q: query }).then((response) => {
        this.loading = false
        this.clients = response.data
      })
    },
  },
  mounted() {
    if (this.value) {
      getAllClient({ id: this.value }).then((response) => {
        this.loading = false
        this.clients = response.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectClient.vue?6ac2ff1e